import React from 'react'
import igIcon from "../../images/igIcon.svg"
import fbIcon from "../../images/fbIcon.svg"
import mobilePictograms from "../../images/mobilePictograms.png"
import "./mobileFooter.css"

const MobileFooter = props => {
    return (
        <div className="mobileFooter">
            <img src={mobilePictograms}
                className="mobilePictograms" />


            <div className='footerText'>• ОСВОЈИ СУПЕР НАГРАДЕ •</div>


            <div className="mobileIcons">
                <a href="https://www.instagram.com/zajecarsko.pivo/" target='_blank'>
                    <img src={igIcon} />
                </a>

                <a href="https://www.facebook.com/pivo.zajecarsko" target='_blank'>
                    <img src={fbIcon} />
                </a>
            </div>

        </div>

    )
}

export default MobileFooter